import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputTextAreaSF from '../../../widgets/form/InputTextAreaSF'
import InputSelectSF from '../../../widgets/form/InputSelectSF'
import InputSelectUI from '../../../widgets/form/InputSelectUI'
import InputReadOnlyUI from '../../../widgets/form/InputReadOnlyUI'

const AccountDescUpdateModalUI = ({ context, successMsg, errorList, setErrorList,
  // modes
  updateMode, submitted,
  // event handlers
  onSubmit, onCancelClick,
  //
  accountName, onAccountNameChange, accountNameError, setAccountNameError,
  businessName, onBusinessNameChange, businessNameError, setBusinessNameError,
  accountDesc, onAccountDescChange, descError, setDescError
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Update account'
    buttonLabel='Update'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputTextSF
      type="text" name="accountName" label="Account Name"
      required={true} value={accountName}
      onChange={onAccountNameChange} error={accountNameError} setError={setAccountNameError}
    />
    <InputTextSF type='text' name='businessName' label='Business name' maxLength={100}
      value={businessName} error={businessNameError}
      onChange={onBusinessNameChange} setError={setBusinessNameError}
      autoFocus={true}
    />

    <InputTextAreaSF type='text' name='accountDesc' label='Account description'
      value={accountDesc} onChange={onAccountDescChange}
      error={descError} setError={setDescError}
    />
  </ModalFormUI>

export default AccountDescUpdateModalUI
